module.exports = __webpack_public_path__ + "/images/hero-catalogo.e67e71f.jpg";